(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yan-purchase-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yan-purchase-guide')) {
    customElements.define('yan-purchase-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.closest('.shopify-section')?.addEventListener('change', () => this.syncEnquiry(), options);
        this.addEventListener('click', () => this.syncEnquiry(), options);
        this.addEventListener('auxclick', () => this.syncEnquiry(), options);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      syncEnquiry() {
        const section = this.closest('.shopify-section');
        const picker = [...(section?.querySelectorAll('variant-picker') || [])].find(element => element.dataset.productId === this.dataset.productId);
        const link = this.querySelector('[data-yan-enquiry-link]');
        if (!picker || !link) return;
        const selected = [...picker.querySelectorAll('fieldset input:checked, select option:checked')];
        if (!selected.length) return;
        const productUrl = new URL(this.dataset.productPath, location.origin);
        const variantId = selected.length === 1 ? selected[0].dataset.variantId : '';
        const optionIds = selected.map(option => option.dataset.optionValueId || '');
        if (/^\d+$/.test(variantId || '')) {
          productUrl.searchParams.set('variant', variantId);
        } else if (optionIds.every(id => /^\d+$/.test(id))) {
          productUrl.searchParams.set('option_values', optionIds.join(','));
        } else {
          return;
        }
        const enquiryUrl = new URL(this.dataset.contactPath, location.origin);
        enquiryUrl.searchParams.set('piece', this.dataset.productTitle);
        enquiryUrl.searchParams.set('piece_url', productUrl.pathname + productUrl.search);
        enquiryUrl.searchParams.set('piece_options', selected.map(option => option.value).join(' / '));
        link.href = enquiryUrl.href;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
